import Vue from 'vue'
import Vuex from 'vuex'
import { pricing } from './pricing.module'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    pricing
  }
})
